/**
 * Note: back-end knows these as discounts while a decision was made
 * to call them promotions in the webapp.
 */

import { Field, ObjectType } from "./decorators";

@ObjectType()
export class PromotionRestriction {
  @Field() public entity!: string;
  @Field() public property!: string;
  @Field() public operator!: string;
  @Field() public value!: string | number | boolean;
}

@ObjectType()
export class PromotionRestrictionSet {
  @Field() public booleanOperator!: 'and' | 'any' | 'not';

  @Field()
  public restrictions!: (PromotionRestriction | PromotionRestrictionSet)[];
}


@ObjectType()
export class PromotionAction {
  @Field() public action!: string;
  @Field() public value!: string | number;
}

@ObjectType()
export class PromotionInput {
  @Field() public inputId!: string;
  @Field() public value!: string | number | boolean;
}

@ObjectType()
export class Promotion {

  @Field() public discountId!: number;
  @Field() public redeemCode!: string;
  @Field() public displayName!: string;
  @Field() public description!: string;
  @Field() public analyticsId?: string;
  @Field() public active!: boolean;
  @Field() public persistent!: boolean;
  @Field() public precedence!: number;
  @Field() public autoApply!: boolean;
  @Field() public used!: boolean;
  @Field() public oneTimeUse!: boolean;
  @Field() public appliesTo!: string;
  @Field() public nsOfferType!: number;
  @Field() public userSelectable!: boolean;
  @Field() public createTime?: Date;
  @Field() public updateTime?: Date;
  @Field() public startDate?: Date;
  @Field() public endDate?: Date;
  public cannotBeCombinedWith?: number[];
  @Field({sub: ()=>PromotionRestriction}) public restrictions?: PromotionRestriction[];
  @Field({sub: ()=>PromotionRestrictionSet}) public restrictionSet?: PromotionRestrictionSet;
  @Field({sub: ()=>PromotionAction}) public actions?: PromotionAction[];
  @Field() public templateUsed?: string;
  @Field() public updatedBy?: string;

  @Field({sub: ()=>PromotionInput})
  public inputs?: PromotionInput[];

  // special fields not in database but synthesized by the API from the restrictions.
  @Field() public accountId?: number[];
  @Field() public scId?: number[];
  
  public companyNames?: string[];


  // client side
  public isExpansionDisplay?: boolean;
}
